module.exports = __webpack_public_path__ + "img/bg-sect-1-mobile.d1f7d4a1.png";